import SectionHeader from "../SectionHeader/SectionHeader";

export default function Section({ title, children, ...rest }) {
  return (
    <section {...rest}>
      <SectionHeader>{title}</SectionHeader>
      {children}
    </section>
  );
}
